export const textSquare = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 4L4 5V23L5 24H23L24 23V5L23 4H5ZM6 22V6H22V22H6ZM12 8H8V12H12V8ZM20 16H8V14H20V16ZM8 20H17V18H8V20Z"
    fill="currentColor"
  />
);
